import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { TemplateOption } from '../template-option';
import * as Styled from './styles';
import * as SX from './sx';
import type { TemplateOptionsProps as Props } from './types';

export const TemplateOptions = memo(
  ({
    className,
    options,
    checkedValues,
    categoryWithNoChildren,
    sx,
    onToggle,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('TemplateOptions', className)}
        sx={SX.root}
      >
        {options.map((item) => (
          <TemplateOption
            key={item.name}
            sx={sx}
            option={item}
            checkedValues={checkedValues}
            categoryWithNoChildren={categoryWithNoChildren}
            onToggle={() => onToggle(item.name)}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

TemplateOptions.displayName = 'TemplateOptions';
